import { HelpPageIconVariant, UniversalHeaderConsumableProps } from '@equipmentshare/universal-header'
import { getPromotionLevel, PROD } from './environment'

// Inventory
export const APP_ID_STAGING = 16
export const APP_ID_PROD = 15

export const getUniversalHeaderConfig = (): Omit<UniversalHeaderConsumableProps, 'tokenGetter'> => {
	const level = getPromotionLevel()
	return {
		environment: level === PROD ? 'production' : 'staging',
		app: {
			id: level === PROD ? APP_ID_PROD : APP_ID_STAGING,
			name: level === PROD ? 'Inventory' : 'Inventory (STAGE)',
			icon: '/favicon.png',
		},
		helpOverride: {
			id: 'universal-header__intercom-trigger',
			text: 'Need Help?',
			variant: HelpPageIconVariant.Button,
		},
	}
}
